var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 39.3333L29.5 29.5L19.6666 39.3333",
    stroke: "#D7DBE0",
    strokeWidth: 4.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29.5V51.625",
    stroke: "#B0C8E6",
    strokeWidth: 4.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1253 45.2088C52.523 43.9016 54.4171 41.8332 55.5087 39.33C56.6003 36.8268 56.8272 34.0313 56.1536 31.3848C55.48 28.7383 53.9442 26.3915 51.7887 24.7148C49.6332 23.038 46.9807 22.1269 44.2498 22.1251H41.1523C40.4082 19.2469 39.0214 16.575 37.096 14.31C35.1706 12.045 32.7568 10.246 30.036 9.04822C27.3152 7.85042 24.3584 7.28499 21.3876 7.39444C18.4169 7.50389 15.5096 8.28538 12.8844 9.68016C10.2592 11.0749 7.98429 13.0467 6.23079 15.4472C4.47728 17.8477 3.29079 20.6145 2.7605 23.5396C2.23021 26.4646 2.36993 29.4719 3.16916 32.3352C3.96838 35.1985 5.40631 37.8433 7.37484 40.0709",
    stroke: "#B0C8E6",
    strokeWidth: 4.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 39.3333L29.5 29.5L19.6666 39.3333",
    stroke: "#B0C8E6",
    strokeWidth: 4.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.6d90ed66.svg";
export { ForwardRef as ReactComponent };